var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49407 14.0909H2.58498C1.78384 14.0909 1.13043 13.4375 1.13043 12.6364V6.81818C1.13043 6.01705 1.78384 5.36364 2.58498 5.36364H18.585C19.3861 5.36364 20.0395 6.01705 20.0395 6.81818V12.6364C20.0395 13.4375 19.3861 14.0909 18.585 14.0909H15.6759",
    stroke: "#00A3FA",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49407 1H15.6759V5.36364H5.49407V1Z",
    stroke: "#00A3FA",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49407 11.1818H15.6759V17H5.49407V11.1818Z",
    stroke: "#00A3FA",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16679 8.27273C4.16679 8.34477 4.11156 8.4 4.03952 8.4C3.96748 8.4 3.91225 8.34477 3.91225 8.27273C3.91225 8.20069 3.96748 8.14546 4.03952 8.14546C4.11156 8.14546 4.16679 8.20069 4.16679 8.27273Z",
    stroke: "#00A3FA",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/print-icon.8ec29f22d91f84029098342bcc86b989.svg";
export { ForwardRef as ReactComponent };